const EventType = {
	Request_Credentials: "Request_Credentials",
	Share_Credentials: "Share_Credentials",
	Flush_Credentials: "Flush_Credentials"	
};

export default EventType